import { useQuery } from '@tanstack/react-query'
import { ClientBenefitConsumptionRecordsService } from '../services/client_benefit_consumption_records.service'
import { APIBenefitConsumptionRecordClientDtoResponse } from '../types'
import { GenericSimpleBag } from '../types/general'
import { defaultQueryOptions } from './common'

export const useClientBenefitConsumptionRecords = (
  locationId: string,
  locationUserProfileId: string,
  options?: GenericSimpleBag
) => {
  return useQuery<APIBenefitConsumptionRecordClientDtoResponse>({
    queryKey: ['clientBenefitConsumptionRecords', locationId, locationUserProfileId, options],
    queryFn: () =>
      ClientBenefitConsumptionRecordsService.getRecordsForUsage(locationId, locationUserProfileId, options),
    enabled: options?.enabled ?? (!!locationId && !!locationUserProfileId),
    ...defaultQueryOptions,
  })
}
